import { render, staticRenderFns } from "./MULTIPLE_CHOICE.vue?vue&type=template&id=6773b6d3&scoped=true&"
import script from "./MULTIPLE_CHOICE.vue?vue&type=script&lang=js&"
export * from "./MULTIPLE_CHOICE.vue?vue&type=script&lang=js&"
import style0 from "./MULTIPLE_CHOICE.vue?vue&type=style&index=0&id=6773b6d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6773b6d3",
  null
  
)

export default component.exports